import { render, staticRenderFns } from "./SessionListItem.vue?vue&type=template&id=18143ba8&scoped=true&"
import script from "./SessionListItem.vue?vue&type=script&lang=ts&"
export * from "./SessionListItem.vue?vue&type=script&lang=ts&"
import style0 from "./SessionListItem.vue?vue&type=style&index=0&id=18143ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18143ba8",
  null
  
)

export default component.exports